module.exports = __webpack_public_path__ + "img/03新聞稿.b4259679.jpg";